/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__ from "@agent-infra/shared";
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_browser_search_e3f2a50c__ from "@agent-infra/browser-search";
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_bing_search_66a8424d__ from "@agent-infra/bing-search";
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_duckduckgo_search_3191b735__ from "@agent-infra/duckduckgo-search";
import * as __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__ from "@agent-infra/logger";
import * as __WEBPACK_EXTERNAL_MODULE__searxng_mjs_16912848__ from "./searxng.mjs";
export * from "./tavily.mjs";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class SearchClient {
    async search(options, originalOptions) {
        switch(this.config.provider){
            case __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider.BrowserSearch:
                {
                    const client = new __WEBPACK_EXTERNAL_MODULE__agent_infra_browser_search_e3f2a50c__.BrowserSearch({
                        logger: this.logger,
                        ...this.config.providerConfig
                    });
                    const searchOptions = {
                        ...originalOptions || {},
                        query: options.query,
                        count: options.count
                    };
                    const results = await client.perform(searchOptions);
                    return {
                        pages: results.map((item)=>({
                                title: item.title,
                                url: item.url,
                                content: item.content
                            }))
                    };
                }
            case __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider.BingSearch:
                {
                    var _response_webPages;
                    const client = new __WEBPACK_EXTERNAL_MODULE__agent_infra_bing_search_66a8424d__.BingSearchClient({
                        logger: this.logger,
                        ...this.config.providerConfig
                    });
                    const searchOptions = {
                        count: options.count,
                        ...originalOptions || {},
                        q: options.query
                    };
                    const response = await client.search(searchOptions);
                    return {
                        pages: ((null === (_response_webPages = response.webPages) || void 0 === _response_webPages ? void 0 : _response_webPages.value) || []).map((item)=>({
                                title: item.name,
                                url: item.url,
                                content: item.snippet
                            }))
                    };
                }
            case __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider.Tavily:
                {
                    const client = tavily(this.config.providerConfig);
                    const searchOptions = {
                        maxResults: options.count,
                        ...originalOptions || {}
                    };
                    const response = await client.search(options.query, searchOptions);
                    return {
                        pages: (response.results || []).map((item)=>({
                                title: item.title || '',
                                url: item.url,
                                content: item.content
                            }))
                    };
                }
            case __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider.SearXNG:
                {
                    const client = (0, __WEBPACK_EXTERNAL_MODULE__searxng_mjs_16912848__.searxng)(this.config.providerConfig);
                    const searchOptions = {
                        count: options.count,
                        ...originalOptions || {},
                        query: options.query
                    };
                    const response = await client.search(options.query, searchOptions);
                    return {
                        pages: (response.results || []).map((item)=>({
                                title: item.title || '',
                                url: item.url,
                                content: item.content
                            }))
                    };
                }
            case __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider.DuckduckgoSearch:
                {
                    const client = new __WEBPACK_EXTERNAL_MODULE__agent_infra_duckduckgo_search_3191b735__.DuckDuckGoSearchClient(this.config.providerConfig);
                    const searchOptions = {
                        ...originalOptions || {}
                    };
                    const response = await client.search({
                        ...searchOptions,
                        retry: {
                            retries: 1,
                            randomize: true
                        },
                        query: options.query,
                        count: options.count
                    });
                    return {
                        pages: (response.results || []).map((item)=>({
                                title: item.title || '',
                                url: item.url,
                                content: item.description
                            }))
                    };
                }
            default:
                throw new Error(`Unsupported search provider: ${this.config.provider}`);
        }
    }
    constructor(config){
        _define_property(this, "config", void 0);
        _define_property(this, "logger", void 0);
        this.config = config;
        this.logger = (null == config ? void 0 : config.logger) ?? __WEBPACK_EXTERNAL_MODULE__agent_infra_logger_ddae3da2__.defaultLogger;
    }
}
var __webpack_exports__SearchProvider = __WEBPACK_EXTERNAL_MODULE__agent_infra_shared_02f0a8bf__.SearchProvider;
export { SearchClient, __webpack_exports__SearchProvider as SearchProvider };

//# sourceMappingURL=index.mjs.map